/**
 * The interface locale (ADR 0051 §6) — not to be confused with `ISettingsProps.Language`,
 * which is the *story* language for word problems and stays untouched by this module.
 *
 * `Locale` is deliberately not part of worksheet state: it goes nowhere near
 * `ISettingsProps`, `generateUrl` or `ProcessUrl`, so it changes no URL key and
 * nothing a seed reproduces. Part 2 resolves it from a `uiLang` query key
 * (`LocaleContext.tsx`) purely as a review affordance — a way to read the
 * catalogue before any localised route exists to carry it. Part 4 is expected
 * to make the route the real source and may keep `uiLang` as an override.
 */
export type Locale = 'en' | 'es' | 'fr';

export const DEFAULT_LOCALE: Locale = 'en';

export const LOCALES: readonly Locale[] = ['en', 'es', 'fr'];

export function isLocale(value: string | null | undefined): value is Locale {
    return value != null && (LOCALES as readonly string[]).includes(value);
}
